export default {
  WORKSHOP_BY_PROFILE: 'workshops/profile/',
  PROFILE: 'workshop_profiles/',
  CARS_LIST: 'car_ownerships/scanned_by_workshop/',
  SCANNED_CAR_DELETE: '/destroy/',
  CAR_OWNERSHIP: 'car_ownerships/',
  VISITS: 'visits/',
  VISIT_ASK_CONFIRM_ADDITIONAL_SERVICE_SCOPE: 'visits/ask_confirm_additional_service_scope/',
  VISIT_ASK_CONFIRM_SERVICE_SCOPE: 'visits/ask_confirm_service_scope/',
  VISIT_BEGIN: 'visits/begin/',
  VISIT_COMPLETE: 'visits/complete/',
  VISIT_FINISH: 'visits/finish/',
  VISIT_PROPOSE_TIME: 'visits/propose_time/',
  VISIT_PROPOSE_NEW_TIME: 'visits/propose_new_time/',
  VISIT_REJECT: 'visits/reject/',
  VISIT_UPDATE_WORKSHOP_MESSAGE: 'visits/update_workshop_message/',
  VISITS_UNSCHEDULED_BY_WORKSHOP_PROFILE: 'visits/workshop_profile/unscheduled/',
  VISITS_FOR_DATE_BY_WORKSHOP_PROFILE: 'visits/workshop_profile/date/',
  VISITS_ONGOING_BY_WORKSHOP_PROFILE: 'visits/workshop_profile/ongoing/',
  VISITS_WEB_CALENDAR_BY_WORKSHOP_PROFILE: 'visits/workshop_profile/web_calendar_date_range/',
  CHECK_PAYMENT_STATUS_WORKSHOP: 'orders/check_payment_status_workshop/',
  REMIND_ABOUT_PAYMENTS: 'orders/remind_about_payment/',
  WORKSHOP_REVIEWS_LIST: 'reviews/list/',
  WORKSHOP_REVIEWS: 'reviews/',
  WORKSHOP_REVIEWS_REPORT: 'report/',
  VISIT_CREATE_BY_WORKSHOP: 'visits/create_by_workshop/',
  EMPLOYEE_REMOVE: 'workshop_ownerships/employee/remove/',
  EMPLOYEE_ADD_OWNER: 'workshop_ownerships/owner/add/',
  EMPLOYEE_REMOVE_OWNER: 'workshop_ownerships/owner/remove/',
  EMPLOYEE_ACTIVE: 'workshop_ownerships/employee/activate/',
  EMPLOYEE_DEACTIVATE: 'workshop_ownerships/employee/deactivate/',
  HISTORY_ENTRIES_BY_CAR: 'services/history_entry/by_car/',
  HISTORY_ENTRY_DETAIL: 'services/history_entry/',
  SERVICE_REPORT_CREATE: 'services/report/create/',
  REGULAR_SERVICES: 'services/regular_service/',
  REGULAR_SERVICES_UPDATE: 'services/regular_service/update/',
  SERVICE_CART_CREATE_ITEM: 'services/cart/create_item/',
  SERVICE_CART_DESTROY_ITEM: 'services/cart/destroy_item/',
  SERVICE_CART_UPDATE_ITEM: 'services/cart/update_item/',
  SUBSCRIPTION_DETAIL: 'subscriptions/subscription/',
  SUBSCRIPTION_CREATE: 'subscriptions/subscription/create/',
  SUBSCRIPTION_CANCEL: 'subscriptions/subscription/cancel/',
  SUBSCRIPTION_INVOICES_LIST: 'subscriptions/invoice/list/',
  SUBSCRIPTION_CUSTOMER_CREATE: 'subscriptions/customer/create/',
  SUBSCRIPTION_PAYMENT_INTENT_CHECK: 'subscriptions/payment_intent/check/',
  HELPDESK_TICKETS: 'helpdesk/ticket/by_user/',
  HELPDESK_CREATE_TICKET: 'helpdesk/ticket/create/',
  WORKSHOP_PROFILE: 'workshop_profiles/',
  WORKSHOP_PROFILE_EDIT: '/update/',
  EMPLOYEES_BY_QUERY: 'workshop_profiles/unassigned/?q=',
  EMPLOYEE_ADD: 'workshop_ownerships/employee/add/',
};
